const GenerateRandomCode = {

   GenerateCode : function(){
      let code = (Math.random().toString(36)+'00000000000000000').slice(2, 8+2)
      return code;
   }
}
export default GenerateRandomCode;